module.exports = __webpack_public_path__ + "static/media/photo303.62095e48.jpg";